// src/firebase/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// IMPORTANT: These values are hardcoded for local development
// In production, they will be replaced by environment variables
const devConfig = {
  apiKey: "AIzaSyD7FhU5fyJSyfAOGM4GPZImzEKeHY5OMGA",
  authDomain: "forfeeder.firebaseapp.com",
  databaseURL: "https://forfeeder.firebaseio.com",
  projectId: "forfeeder",
  storageBucket: "forfeeder.appspot.com",
  messagingSenderId: "929842031879",
  appId: "1:929842031879:web:75e96bd21f34053b2f69a2",
  measurementId: "G-MCV8BFJPDS"
};

// In CI/CD environments (GitHub Actions), use environment variables
// Otherwise, fall back to hardcoded development values
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || devConfig.apiKey,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || devConfig.authDomain,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || devConfig.databaseURL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || devConfig.projectId,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || devConfig.storageBucket,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || devConfig.messagingSenderId,
  appId: process.env.REACT_APP_FIREBASE_APP_ID || devConfig.appId,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || devConfig.measurementId
};

// Validate configuration
const requiredFields = ['apiKey', 'authDomain', 'projectId'];
const missingFields = requiredFields.filter(field => !firebaseConfig[field]);

if (missingFields.length > 0) {
  console.error('❌ Missing Firebase configuration fields:', missingFields);
  console.error('Please check your .env file and ensure all REACT_APP_FIREBASE_* variables are set');
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Configure auth settings for development
if (process.env.REACT_APP_ENVIRONMENT === 'development') {
  // Disable app verification for testing (helps with reCAPTCHA issues)
  // Uncomment the line below if you're having reCAPTCHA issues in development
  // auth.settings.appVerificationDisabledForTesting = true;
  
  console.log('🔧 Firebase initialized in development mode');
  console.log('📱 Project ID:', firebaseConfig.projectId);
  console.log('🔐 Auth Domain:', firebaseConfig.authDomain);
}

// Add global Firebase error monitoring to help debug unhandled promise rejections
if (process.env.NODE_ENV === 'development') {
  // Monitor Firebase Auth state changes for errors
  auth.onAuthStateChanged(
    (user) => {
      console.log('📱 Auth state changed:', user ? `User: ${user.uid}` : 'No user');
    },
    (error) => {
      console.error('🚨 Firebase Auth error:', error);
    }
  );
  
  // Monitor for Firebase connection errors
  const onError = (error) => {
    console.error('🚨 Firebase connection error:', {
      code: error.code,
      message: error.message,
      stack: error.stack
    });
  };
  
  // Add error listener for Firestore if available
  if (db) {
    console.log('🔥 Firestore monitoring initialized');
  }
}

export { app, auth, db, storage, RecaptchaVerifier, signInWithPhoneNumber };